// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCYG8z4kqwB12LKlrPTks70VsIPLrJ43vc",
  authDomain: "cybershield-24f97.firebaseapp.com",
  projectId: "cybershield-24f97",
  storageBucket: "cybershield-24f97.appspot.com",
  messagingSenderId: "977427913176",
  appId: "1:977427913176:web:03cd38ba4509835872baad"
};

// Initialize Firebase
initializeApp(firebaseConfig);